<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!--内容-->
    <div class="content-wrap">
      <div class="par-box" v-for="item of parList">
        <div class="par-cont">
          <div class="img-div">
            <img :src="imgUrl+item.channelImgUrl" class="img">
          </div>
          <p class="name">{{ item.channelName }}</p>
          <p v-if="item.channelContactTeacher"><span>联系电话：</span><span v-for="(phone, index) in item.channelContactTeacher.split(',')" :key="index" class="phone">{{ phone }}</span></p>
          <p v-if="item.authorizedArea"><span>授权区域：</span>{{ item.authorizedArea }}</p>
          <p v-if="item.channelMajorName"><span>独家授权：</span>{{ item.channelMajorName }}</p>
          <p v-if="item.channelNormalMajorName"><span>授权专业：</span><span class="major-name" v-for="(item, index) in item.channelNormalMajorName.split(' ')" :key="index">{{ item }}</span>
            {{item.majorDirection}}</p>
<!--          <p v-if="item.channelNormalMajorName"><span>授权专业：</span>{{ item.channelNormalMajorName }} {{item.majorDirection}}</p>-->
          <a :href="item.authorizationStatementMobile" target="_blank" v-if="item.authorizationStatementMobile"><span>授权声明：</span>{{ item.authorizationStatementMobile }}</a>
          <!--          <p>一般授权：{{ item.cont2 }}</p>-->
          <!--          <a :href="item.cont3" target="_blank" v-if="item.cont3 != null">授权声明：{{ item.cont3 }}</a>-->
          <!--          <div class="img-div">-->
          <!--            <img :src="item.pic" class="img"></div>-->
          <!--            <p class="name">{{ item.name }}</p>-->
          <!--            <p>{{ item.phone }}</p>-->
          <!--            <p>{{ item.cont1 }}</p>-->
          <!--            <p>{{ item.cont2 }}</p>-->
          <!--            <p>{{ item.cont4 }}</p>-->
          <!--            <a :href="item.cont3" target="_blank" v-if="item.cont3 != null">授权声明：{{ item.cont3 }}</a>-->
        </div>
      </div>
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";
import {getChannelList} from '@/apis/apis'

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      imgUrl: "https://service.yzvet.com/haip-file/download?fileName=&fileUrl=",
      parList: [
        {
          channelImgUrl:'',
          channelName:'',
          channelContactTeacher:'',
          authorizedArea:'',
          channelMajorName:'',
          channelNormalMajorName:'',
          authorizationStatement:'',
          authorizationStatementMobile:'',
          majorDirection:''
        }
        // {
        //   pic: "https://img.yzvet.com/alumni/partner/xuechang.png",
        //   name: "学畅国际教育",
        //   phone: "联系电话：储老师 4008870118",
        //   cont1: "授权区域：中国区域",
        //   cont2: "独家授权：工商管理硕士",
        //   cont3: "https://m.brest-bs.com.cn/newsDetails?cmsId=296",
        //   cont4: ""
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-hslj.jpeg"),
        //   name: "华商领军",
        //   phone: "联系电话：李老师 15803875163",
        //   cont1: "授权区域：中国区域",
        //   cont2: "独家授权：资产管理与金融硕士",
        //   cont3: "https://m.brest-bs.com.cn/newsDetails?cmsId=297",
        //   cont4: "一般授权：工商管理博士（DBA）"
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-derm.png"),
        //   name: "德瑞姆应用心理学院",
        //   phone: "联系电话：李老师 4008202621",
        //   cont1: "授权区域：中国区域",
        //   cont2: "独家授权：应用心理学与管理博士",
        // },
        // {
        //   pic:"https://img.yzvet.com/alumni/partner/huashang.png",
        //   name: "时代华商",
        //   phone: "联系电话：4009-020-882",
        //   cont1: "授权区域：中国区域",
        //   cont2: "一般授权：资产管理与金融硕士、工商管理博士（DBA)",
        //   cont3: "https://m.brest-bs.com.cn/newsDetails?cmsId=433",
        //   cont4: ""
        // },
        // {
        //   pic:"https://img.yzvet.com/alumni/partner/nanhai.png",
        //   name: "南海教育集团",
        //   phone: "联系电话：余广生  13823367816",
        //   cont1: "",
        //   cont2: "教育管理硕士 音乐方向",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-zhongcai.png"),
        //   name: "中财教联",
        //   phone: "联系电话：刘老师 010-57267770",
        //   cont1: "地址：北京市海淀区高粱桥斜街59号中坤大厦1409",
        //   cont2: "独家授权：会计与管理专业硕士",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-gaojing.png"),
        //   name: "高景亚太",
        //   phone: "联系电话：张老师 15910896781",
        //   cont1: "授权区域：中国区域",
        //   // cont2: "代理项目：房地产经济与管理硕士",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-chuangzaoying.png"),
        //   name: "营创商学院",
        //   phone: "联系电话：苏老师 18515981662",
        // },
        // {
        //   pic: "https://img.yzvet.com/alumni/partner/shangshuai.png",
        //   name: "商帅商学院",
        //   phone: "联系电话：李老师 18511373308",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-laien.png"),
        //   name: "莱恩商学院",
        //   phone: "联系电话：18128845759",
        //   phone1: "0755-86705759"
        // },
        // {
        //   pic: "https://img.yzvet.com/alumni/partner/zixin.png",
        //   name: "子信教育",
        //   phone: "联系电话：李老师 18118198201",
        //   phone1: "13771901798"
        // },
        // {
        //   pic:"https://img.yzvet.com/alumni/partner/huibo.png",
        //   name: "汇博管理研究院",
        //   phone: "联系电话：18309286699",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/pat-wodun.png"),
        //   name: "沃顿教育",
        //   phone: "联系电话：025-86700683",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-dongri.png"),
        //   name: "福州东日教育",
        //   phone: "联系电话：滕老师 18650339337",
        //   phone1: "黄老师 18559936505"
        // },
        // // {
        // //   pic: require("../../assets/images/dailishang/par-gaofeng.png"),
        // //   name: "哈尔滨峰高教育",
        // //   phone: "联系电话：400-007-6757",
        // // },
        // {
        //   pic: require("../../assets/images/dailishang/par-tongxin.png"),
        //   name: "通信企业协会",
        //   phone: "联系电话：宋老师 18612568779",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-hanyuan.png"),
        //   name: "汉元商学",
        //   phone: "联系电话：乐乐老师 13210864117",
        // },
        // {
        //   pic: require("../../assets/images/dailishang/par-nanfang.png"),
        //   name: "南方商业研究院",
        //   phone: "联系电话：甄老师 13826259394",
        // },
        // {
        //   pic:"https://img.yzvet.com/alumni/partner/fenggao.png",
        //   name: "哈尔滨峰高教育科技集团有限公司",
        //   phone: "联系电话：杨老师 13936258005",
        // },
        //  {
        //   pic:"https://img.yzvet.com/alumni/partner/saiyou.png",
        //   name: "北京赛优职教育科技有限公司",
        //   phone: "联系电话：刘洁 15901086626",
        // },
        // {
        //   pic:"https://img.yzvet.com/alumni/partner/shenzhou.png",
        //   name: "江苏莘洲教育科技有限公司",
        //   phone: "联系电话：许老师 13382236250",
        // },
        // {
        //     pic: "https://img.yzvet.com/alumni/partner/shanghaijingfu.png",
        //     name: "上海敬敷教育科技有限公司",
        //     phone: "联系电话：胡老师 18217005260"
        // },
        // {
        //     pic: "https://img.yzvet.com/alumni/partner/suzhoudelian.png",
        //     name: "苏州德联教育科技有限公司",
        //     phone: "联系电话：林老师 0512-89573556"
        // }, {
        //     pic: "https://img.yzvet.com/alumni/partner/wenshanzhihe.png",
        //     name: "文商致和管理研究院",
        //     phone: "联系电话：孙老师 13201826888"
        // }
      ]
    };
  },
  methods: {
    //获取渠道内容
    async getChannelList() {
      try {
        let params = {
          pageSize: 0,
          beactive: 1
        };
        let {
          data
        } = await getChannelList(params);
        this.parList = data.data.content;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.getChannelList()
  }
};
</script>
<style scoped>
.banner-info {
  width: 100%;
  height: 200px;
  background: url('../../assets/images/banner002.png');
  background-size: 100% 100%;
}

.content-wrap {
  width: 95%;
  margin: 0 auto;
}

/*内容*/
.par-box {
  background: #ececec;
  border-radius: 10px;
  border-bottom: 10px solid #e58111;
  margin: 40px 0;
  padding: 30px 20px;

}
.major-name{
  display: inline-block;
}
.major-name + .major-name {
  margin-left: 24%; /* 根据需要调整数值 */
}
.img-div {
  height: 180px;
  border-bottom: 1px solid #ccc;
  position: relative;
}

.img {
  max-width: 100%;
}

.par-cont img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.par-cont p,a {
  font-size: 32px;
  line-height: 60px;
}

.phone + .phone {
  display: block;
  margin-left: 24%; /* 根据需要调整数值 */
}

.par-cont .name {
  color: #E58111;
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/pages/admissions/agentPage.vue